import { createSlice, PayloadAction } from "@reduxjs/toolkit";


interface Course {
    course: any;
    // next: string | null;
    // previous: string | null;
    count: number | null;
    // totalPages: number | null;
    isLoading: boolean;
    error: string | null;
    examScores: {  // Add a new field to store the exam scores
        total: number;
        reading_writing: number;
        math: number;
        CurrentPercentile: number;
    } | null;
}

const initialState: Course = {
    course: [],
    // next: null,
    // previous: null,
    count: 0,
    // totalPages: 0,
    isLoading: false,
    error: null,
    examScores: null, // Initialize it as null
};

const courseSlice = createSlice({
    name: "courseData",
    initialState,
    reducers: {
        setgetCourse: (state: Course, action: PayloadAction<Course>) => {
            state.course = action.payload;
            state.isLoading = false;
            state.error = null;
        },
        setloading: (state: Course, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
            state.error = null;
        },
        seterror: (state: Course, action: PayloadAction<string>) => {
            state.error = action.payload;
            state.isLoading = false;
        },
        setCompetitiveExamScores: (state: Course, action: PayloadAction<any>) => {
            state.examScores = action.payload;  // Set the exam score data
        },
        resetgetCompetitiveExamScore: () => {
            return initialState;
        },
    },
});

export const {
    setgetCourse,
    setloading,
    seterror,
    setCompetitiveExamScores,
    resetgetCompetitiveExamScore,
} = courseSlice.actions;

export default courseSlice.reducer;
